var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._b({attrs:{"type":"secondary","loading":_vm.loading,"disabled":_vm.disabled,"icon":_vm.icon,"title":_vm.title,"active":_vm.selected},on:{"click":function($event){$event.preventDefault();return _vm.select(_vm.value)}}},'Button',_vm.restProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }